import type { NextPage } from 'next'
import { useRouter } from 'next/router'
import { useEffect, useState } from 'react'
import { ParsedUrlQuery } from 'querystring'

import { IPagination , IPaginationProp, IQuery } from './interfaces'
import { PaginationModel } from './model'

import Pagination1 from './pagination1'
import Pagination2 from './pagination2'
import Pagination3 from './pagination3'
import Pagination4 from './pagination4'
import Pagination5 from './pagination5'


const getParsedPaginationQuery = (q: ParsedUrlQuery): IQuery => {
  const page: number = q.page ? Number(q.page) : 1;
  const limit: number = q.limit ? Number(q.limit) : 10;
  const query: string = q.query ? String(q.query) : '';
  const filters: string = q.filters ? String(q.filters) : '';
  return { page, limit, query, filters }
}

const PaginationComponent: NextPage<IPagination> = ({ limit, totalRecords, pageItemLength, theme, type, callback, currentPage }) => {
  const Router = useRouter()
  const [pageItems, setPageItems] = useState<IPaginationProp>({})

  limit = limit || 10
  totalRecords = totalRecords || 0
  let totalPages = Math.ceil((totalRecords / limit!))
  totalPages = (totalPages <= 1) ? 1 : totalPages

  useEffect(() => {
    const _PaginationModel = new PaginationModel();
    _PaginationModel.setPathName = Router.pathname
    _PaginationModel.setParsedQuery = Router.query
    _PaginationModel.setCurrentPage = +Router.query.page! || 1
    _PaginationModel.setLimit = limit
    _PaginationModel.setTotalPages = totalPages
    _PaginationModel.setTotalRecords = totalRecords
    _PaginationModel.setPageItemLength = pageItemLength
    _PaginationModel.setType = type || "default"
    if (callback) {
      _PaginationModel.setCallback = callback
    }

    if (currentPage) {
      _PaginationModel.setCurrentPage = currentPage
    }

    const items = _PaginationModel.getItems()
    setPageItems(items)
  }, [Router, limit, totalPages, totalRecords, pageItemLength, type, callback, currentPage, setPageItems])

  return (
    <div className="my-6">
      {(theme === 'theme1') && <Pagination1 items={pageItems} />}
      {(theme === 'theme2') && <Pagination2 items={pageItems} />}
      {(theme === 'theme3') && <Pagination3 items={pageItems} />}
      {(theme === 'theme4') && <Pagination4 items={pageItems} />}
      {(theme === 'theme5' || theme === undefined || theme === 'default') && <Pagination5 items={pageItems} />}
    </div>
  )
}

export const paginationToFitInterface = (apiPaginationResult: { limit: number, total_record: number, current_page: number, total_page: number}): IPagination => {
  return {
    limit: apiPaginationResult.limit,
    totalPages: apiPaginationResult.total_page,
    totalRecords: apiPaginationResult.total_record,
    currentPage: apiPaginationResult.current_page,
  }
}

export {
  type IPagination,
  PaginationComponent,
  getParsedPaginationQuery
}
